module.exports = __webpack_public_path__ + "img/producto.3d96886f.png";